// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import { DrugScreenTag, PatientVisitTag, IdVerificationStatusTag } from 'ui_kit_qmd'
import moment from 'moment-timezone'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import { visitListStatuses, visitsListModes, visitsStatuses } from '../../../utils/constants'
import { getFullName, getFullNameWithPrfix, getProviderDisplayName } from '../VisitTools'
import { UNASSIGNED_PROVIDER_TEXT } from '../constants'
import bellIcon from '../../../images/common/bellIcon.png'
import BookingId from '../../../components/bookingId/BookingId'
import { VisitStatusIcon } from '../VisitStatusIcon/VisitStatusIcon'
import { isDrugScreenTagClickable } from '../../../utils/common'
import RescheduleVisit from '../../../components/reschedule-visit/RescheduleVisit'
import { getVisitMethodIconProps } from '../../new-visit/components/visit-information/getVisitMethodIconProps'
import { getVisitTypeLabel } from '../../../utils/getVisitTypeLabel'

const DEFAULT_VALUE = '--'

export const visitDataItem = (
  {
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    IsNewForPatient,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    IsNewForServiceType,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    IsPriceChanged,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    Coverage,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    IsVisitTypeAvailable,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    onClickRemarks,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    VisitDateTime,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    CreateDateTime,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    Status,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    Method,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    VisitTypeName,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    Provider,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    visitsMode,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    Patient,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    visitId,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    PaymentTransactionId,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    VisitNumber,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    timeZone,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    onClickBookingId,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    IsCancellationAllowed,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    getFile,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    getIDVerificationInfo,
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    showIDTag,
  },
  redirectToRescheduleVisitPage = () => {},
) => {
  const hasVisitStatusIcon = visitsMode === visitsListModes.UPCOMING_MODE || Status === visitListStatuses.UNRESOLVED

  const icon =
    Method ?
      // eslint-disable-next-line jsx-a11y/alt-text -- alt is provided by getVisitMethodIconProps
      <img className='visit-type-icon' {...getVisitMethodIconProps(Method)} />
    : ''

  const dateTimeFormatted =
    timeZone ?
      moment(VisitDateTime).parseZone().tz(timeZone, false).format('MMM DD, YYYY')
    : moment(VisitDateTime).format('MMM DD, YYYY')
  const dayTimeFormatted =
    timeZone ?
      moment(VisitDateTime).parseZone().tz(timeZone, false).format('h:mma')
    : moment(VisitDateTime).format('h:mma')

  const date = {
    sectionContent:
      dateTimeFormatted && dayTimeFormatted ?
        <section className='visit-date-target-section'>
          <div className='visit-date'>{dateTimeFormatted}</div>
          <div className='visit-date'>{dayTimeFormatted}</div>
        </section>
      : DEFAULT_VALUE,
  }

  const scheduledOn = {
    sectionContent:
      CreateDateTime ?
        timeZone ? moment(CreateDateTime).tz(timeZone, false).format('MMM DD, YYYY')
        : moment(CreateDateTime).format('MMM DD, YYYY')
      : DEFAULT_VALUE,
  }

  const status = {
    sectionContent: visitsStatuses[Status] ?? DEFAULT_VALUE,
    tooltip: visitsStatuses[Status],

    afterContentIcon:
      hasVisitStatusIcon ?
        visitsMode === visitsListModes.UPCOMING_MODE ?
          <div className={classNames('visit-status-icon-container', { 'without-cancel': !IsCancellationAllowed })}>
            <RescheduleVisit
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              isPriceChanged={Boolean(IsPriceChanged) && !Coverage}
              IsVisitTypeAvailable={IsVisitTypeAvailable}
              status={Status}
              redirectToRescheduleVisitPage={redirectToRescheduleVisitPage}
            />
            {IsCancellationAllowed ?
              <VisitStatusIcon isCancellationAllowed={IsCancellationAllowed} visitId={visitId} />
            : null}
          </div>
        : <VisitStatusIcon isCancellationAllowed={IsCancellationAllowed} visitId={visitId} />
      : null,
  }

  const visit = {
    sectionContent:
      VisitTypeName ?
        <>
          {icon}
          <span className='visit-type-name'>{getVisitTypeLabel(VisitTypeName, Method)}</span>
        </>
      : DEFAULT_VALUE,
    tooltip: getVisitTypeLabel(VisitTypeName, Method),
  }

  const provider = {
    sectionContent:
      Provider && Object.keys(Provider).length ?
        <Link
          className='visit-item-link'
          target='_blank'
          to={`/management/member?type=Provider&id=${Provider.ProviderId}`}>
          {getFullNameWithPrfix(Provider)}
        </Link>
      : UNASSIGNED_PROVIDER_TEXT,
    tooltip: getProviderDisplayName(Provider),
  }

  const patient = {
    sectionContent:
      Patient ?
        <Link className='visit-item-link' target='_blank' to={`/patient-chart?id=${Patient.PatientId}`}>
          {getFullName(Patient)}
        </Link>
      : DEFAULT_VALUE,
    tooltip: getFullName(Patient),
  }

  const tags = {
    sectionContent:
      visitsMode === visitsListModes.UPCOMING_MODE && (IsNewForPatient || IsNewForServiceType) ?
        <div className='visit-tag'>
          <PatientVisitTag
            className='visits-list-patient-tag'
            isNewForPatient={IsNewForPatient}
            isNewForServiceType={IsNewForServiceType}
          />
        </div>
      : null,
    afterContentIcon: (
      <>
        {showIDTag && Patient?.IdentityVerification ?
          <IdVerificationStatusTag
            tagStatus={Patient.IdentityVerification?.Status}
            className='visits-table-voucher-id-tag'
            onClick={getIDVerificationInfo}
            requestDateTime={Patient.IdentityVerification.RequestDateTime}
          />
        : null}
        {Patient.DrugScreen ?
          <DrugScreenTag
            className='visits-table-drug-screen-tag'
            type={Patient?.DrugScreen.Status}
            completedDate={Patient?.DrugScreen.CompleteDate}
            expiredDate={Patient?.DrugScreen.ExpireDate}
            onClick={
              isDrugScreenTagClickable(Patient?.DrugScreen.Status, Patient?.RestrictionStatus === 'merged') ? getFile
              : null
            }
          />
        : null}
      </>
    ),
  }

  const remarks = {
    sectionContent: (
      <img
        role='presentation'
        src={bellIcon}
        data-id={visitId}
        className='remarks-bell-icon'
        onClick={onClickRemarks}
        alt='bellIcon'
      />
    ),
  }

  const screening = {
    sectionContent: DEFAULT_VALUE,
  }

  const paymentId = {
    sectionContent:
      PaymentTransactionId ? <span className='visit-payment-id'>{PaymentTransactionId}</span> : DEFAULT_VALUE,
    tooltip: PaymentTransactionId,
  }

  const bookingId = {
    sectionContent:
      VisitNumber ?
        <BookingId VisitNumber={VisitNumber} VisitId={visitId} onClickBookingId={onClickBookingId} />
      : DEFAULT_VALUE,
  }

  const transId = {
    sectionContent: DEFAULT_VALUE,
  }

  return {
    date,
    scheduledOn,
    status,
    visit,
    provider,
    patient,
    remarks,
    screening,
    paymentId,
    bookingId,
    transId,
    tags,
  }
}
